import React, { useCallback } from 'react';
import Search from '../components/Search';
import Breadcrumbs from '../components/Breadcrumbs';
import Spinner from "../components/Spinner";

const ProductTypePage = ({ params: { productType: preselect } = {}, loading, complete, data: { category, ...productType } = {} }) => {
  const formatBreadcrumbs = useCallback((crumb, index, isLast) => {
    if (index === 1 && category?.name?.length) {
      return category.name;
    }
    if (isLast && productType?.name?.length) {
      return productType.name;
    }
    return crumb.replace(/-/g, ' ').trim();
  }, [category, productType]);

  return (
    loading ? <Spinner/> :
    <>
      <Breadcrumbs formatter={formatBreadcrumbs} />
      <Search category={category} preselect={preselect} productType={complete ? productType : undefined} />
    </>
  );
};

export default ProductTypePage;